import type { DetailFormJsMethodProps } from './registry';

export const getEmployeePhotoValue = (
  values: Record<string, unknown>,
  fields: DetailFormJsMethodProps['fields'],
  name: string
): unknown => {
  if (name in values) {
    return values[name];
  }

  const metadata = fields.find(
    (candidate) => candidate.dataField === name || candidate.field === name
  );
  const dataField = metadata?.dataField ?? metadata?.field;
  return dataField ? values[dataField] : undefined;
};

export const toPositiveInteger = (value: unknown): number | null => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : null;
};

export const getEmployeePhotoInitials = (initialsValue: unknown, nameValue: unknown): string => {
  if (typeof initialsValue === 'string' && initialsValue.trim()) {
    return initialsValue.trim();
  }

  const parts = typeof nameValue === 'string' ? nameValue.trim().split(/\s+/).filter(Boolean) : [];
  if (parts.length > 1) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  return (parts[0] ?? '').slice(0, 2).toUpperCase();
};
